// @flow
import { Component } from '@angular/core';

@Component({
  selector: 'nostorage',
  template: require('./nostorage.html')
})
export class NoStorageComponent {
}
